import React from "react";
import { observer, inject } from "mobx-react";
import { observable, computed } from "mobx";

import { Values } from "@src/Tools/Values";
import { STFabTooltip } from "@src/Components/Ui/STFab";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import { Grid } from "@material-ui/core";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import ChangePermissionForm, {
  IPermissionForm,
} from "./ChangePermissionForm/ChangePermissionForm";
import { IManagementStore } from "@src/Stores/Management/types";
import styled from "styled-components";
import { orange } from "@material-ui/core/colors";
import { Person } from "@src/Interfaces/Entity/Person";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

const STFabTooltipDanger = styled(STFabTooltip).attrs({
  classes: {
    primary: "Primary",
  },
})`
  && {
    .Primary {
      background-color: black;
    }

    ${(props: any) =>
      props.selected ? `background-color:  ${orange[400]}` : null};

    :hover {
      ${(props: any) =>
        props.selected ? `background-color:  ${orange[500]}` : null};
    }
  }
`;

interface IProps {
  person: Person;
  management?: IManagementStore;
}

@inject("management")
@observer
export default class PersonPermission extends React.Component<IProps> {
  @observable isOpened: boolean = false;

  @computed get isSelected() {
    return (
      this.props.person.permissions &&
      this.props.person.permissions !== null &&
      this.props.person.permissions.length > 0
    );
  }

  handleOpen = () => {
    this.isOpened = true;
  };

  handleClose = () => {
    this.isOpened = false;
  };

  handleSubmit = async (values: IPermissionForm) => {
    await this.props.management.savePerson({
      ...this.props.person,
      permissions: values.permissions,
    });

    this.handleClose();
  };

  render() {
    return (
      <>
        <RoundButton
            icon={<LockOpenIcon/>}
            tooltipTitle={Values.getLocalizationValue("permissions")}
            onClick={() => this.handleOpen()}
            color={this.isSelected ? "orange" : "default"}
        />
        
        <SimpleModal
          width={500}
          isOpened={this.isOpened}
          onClose={this.handleClose}
        >
          <ChangePermissionForm
            personPermissions={this.props.person.permissions}
            onSubmit={this.handleSubmit}
          >
            <Grid container justify="center">
              <STButtonMargin type="submit" variant="contained" color="primary">
                <DoneIcon />
              </STButtonMargin>
              <STButtonMargin onClick={this.handleClose} variant="contained">
                <ClearIcon />
              </STButtonMargin>
            </Grid>
          </ChangePermissionForm>
        </SimpleModal>
      </>
    );
  }
}
